<template lang="pug">
  v-layout
    v-card.box-card-mis-seguros-formatter(v-if="openPopup")
      v-card-text
        v-layout(column align-center)
          v-flex.box-tooltip-generico-formatter.box-tooltip-formatter1(v-show="flag1")
          v-flex.box-tooltip-generico-formatter.box-tooltip-formatter2(v-show="flag2")
          v-flex.box-tooltip-generico-formatter.box-tooltip-formatter3(v-show="flag3")
          v-flex(style="width: 100%;position: absolute;top: 0;right: 0;")
            v-btn(icon dark style="float: right;" @click="closeTooltip(false)")
              v-icon(color="#0855C4") close
          v-flex(style="padding-top: 1em;")
            v-img
              img(
                style="height:150px;width:150px"
                :src="icon")
          v-flex
            span(style="font-weight: 600;font-size: 24px;color: #0855C4;") {{titulo || '¡Hola!'}}
          v-flex(style="text-align: center;height: 8em;margin: 5px 5px")
            span(style="font-size:18px;color:#535D66;line-height:normal") {{mensaje}}
          v-flex(style="width:100%")
            v-layout(row wrap)
              v-flex(xs5 style="align-self: center;")
                .box-guia-formatter
                  div.box-point(@click="sliderPopupSelected(0)")
                  div.box-point(@click="sliderPopupSelected(1)")
                  div.box-point(@click="sliderPopupSelected(2)")
                  div.box-point(v-if="!oriProducto.includes('VIDA_CASH_PLUS')" @click="sliderPopupSelected(oriProducto.includes('VIDA_CASH_PLUS') ? 0 : 3)")
              v-flex(xs3 style="align-self: center;")

                span.box-salir-tooltip(
                v-if="this.flagSlider >= 1 && this.flagSlider <= 3"
                  style="display: flex;justify-content: center;color: #454A6C;font-size: 16px;"
                  @click="backTooltip()"
                  ) Atrás
                span.box-salir-tooltip(
                v-if="this.flagSlider === 0"
                  style="display: flex;justify-content: center;color: #454A6C;font-size: 16px;"
                  @click="sliderPopup(true)"
                  ) Salir
              v-flex(xs4 )
                v-btn(style="background: #EA0D90;" @click="sliderPopup()" )
                  span(style="color:#ffffff;text-transform: capitalize;") {{flagSlider === 3 || (oriProducto.includes('VIDA_CASH_PLUS') && flagSlider ===2)? 'Salir': 'Siguiente'}}
</template>

<script>

export default {
  props: [
    'openPopup',
    'producto',
    'oriProducto'
  ],
  data () {
    return {
      titulo: '',
      icon: require('@/assets/characters/informa.svg'),
      flag1: false,
      flag2: false,
      flag3: false,
      flagSlider: 0,
      pg: {
        plan: 'En esta sección podrás consultar y gestionar tus seguros de manera rápida y sencilla.',
        hoy: 'Aquí encontrarás, como va tu seguro a la fecha.',
        proyeccion: 'Aquí podrás visualizar tus montos de ahorro a futuro.',
        hola: 'Te enseñamos a descubrir como usar lo nuevo de Mis Seguros'
      },
      vf: {
        plan: 'En esta sección podrás consultar y gestionar tus seguros de manera rápida y sencilla.',
        hoy: 'Aquí encontrarás, como va tu seguro a la fecha.',
        proyeccion: 'Aquí podrás visualizar el crecimiento de tus ahorros más tu rentabilidad en el futuro.',
        hola: 'Te enseñamos a descubrir como usar lo nuevo de Mis Seguros.'
      },
      auxMessage: {},
      mensaje: ''
    }
  },
  methods: {
    sliderPopup (flag) {
      const vidaCashPlus = (this.oriProducto || '').includes('VIDA_CASH_PLUS')
      if (this.flagSlider === (vidaCashPlus ? 2 : 3) || flag) {
        this.closeTooltip()
      }

      let points = document.querySelectorAll('.box-guia-formatter .box-point')
      if (points.length === 0) {
        return
      }
      // let salir = document.querySelector(".box-card-mis-seguros-formatter .box-salir-tooltip")

      this.flag1 = false
      this.flag2 = false
      this.flag3 = false

      if (points.length < 1) {
        return
      }
      points[0].style.background = '#D9D9D9'
      points[1].style.background = '#D9D9D9'
      points[2].style.background = '#D9D9D9'
      if (!vidaCashPlus) {
        points[3].style.background = '#D9D9D9'
      }

      if (this.flagSlider >= (vidaCashPlus ? 2 : 3)) {
        this.flagSlider = 0
      } else {
        this.flagSlider++
      }

      switch (this.flagSlider) {
      case 1:
        this.flag1 = true
        points[1].style.background = '#0855C4'
        this.titulo = 'Plan'
        this.mensaje = this.auxMessage.plan
        this.icon = require('./../../assets/icons-mis-seguros/icon-mis-seguros-plan.svg')
        break
      case 2:
        this.flag2 = true
        points[2].style.background = '#0855C4'
        this.titulo = 'Hoy'
        this.mensaje = this.auxMessage.hoy
        this.icon = require('./../../assets/icons-mis-seguros/icon-mis-seguros-hoy.svg')
        break
      case 3:
        this.flag3 = true
        points[3].style.background = '#0855C4'
        this.titulo = 'Proyección'
        this.mensaje = this.auxMessage.proyeccion
        this.icon = this.producto !== 'PLANGARANTIZADO' ? require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion-vf1.svg') : require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion.svg')
        break
      default:
        points[0].style.background = '#0855C4'
        this.titulo = '¡Hola!'
        this.mensaje = this.auxMessage.hola
        this.icon = require('@/assets/characters/informa.svg')
        break
      }
    },
    sliderPopupSelected (item) {
      const vidaCashPlus = (this.oriProducto || '').includes('VIDA_CASH_PLUS')
      let points = document.querySelectorAll('.box-guia-formatter .box-point')
      if (points.length === 0) {
        return
      }
      if (vidaCashPlus && item >= 2) {
        item = 0
      }
      this.flagSlider = item

      this.flag1 = false
      this.flag2 = false
      this.flag3 = false
      points[0].style.background = '#D9D9D9'
      points[1].style.background = '#D9D9D9'
      points[2].style.background = '#D9D9D9'
      if (!vidaCashPlus) {
        points[3].style.background = '#D9D9D9'
      }
      switch (item) {
      case 1:
        this.flag1 = true
        points[1].style.background = '#0855C4'
        this.titulo = 'Plan'
        this.mensaje = this.auxMessage.plan
        this.icon = require('./../../assets/icons-mis-seguros/icon-mis-seguros-plan.svg')
        break
      case 2:
        this.flag2 = true
        points[2].style.background = '#0855C4'
        this.titulo = 'Hoy'
        this.mensaje = this.auxMessage.hoy
        this.icon = require('./../../assets/icons-mis-seguros/icon-mis-seguros-hoy.svg')
        break
      case 3:
        this.flag3 = true
        points[3].style.background = '#0855C4'
        this.titulo = 'Proyección'
        this.mensaje = this.auxMessage.proyeccion
        this.icon = this.producto !== 'PLANGARANTIZADO' ? require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion-vf1.svg') : require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion.svg')
        break
      default:
        points[0].style.background = '#0855C4'
        this.titulo = '¡Hola!'
        this.mensaje = this.auxMessage.hola
        this.icon = require('@/assets/characters/informa.svg')
        break
      }
    },
    initPopUp () {
      this.flag1 = false
      this.flag2 = false
      this.flag3 = false
      this.titulo = '¡Hola!'
      this.mensaje = this.auxMessage.hola
      this.icon = require('@/assets/characters/informa.svg')
    },
    backTooltip () {
      let item = this.flagSlider - 1
      this.sliderPopupSelected(item)
    },
    closeTooltip () {
      this.flagSlider = 0
      this.sliderPopupSelected(0)
      this.$emit('closePopup')
    }

  },
  mounted () {
    if (this.producto !== 'PLANGARANTIZADO') {
      this.auxMessage = { ...this.vf }
    } else {
      this.auxMessage = { ...this.pg }
    }
    this.initPopUp()
    this.sliderPopup()
    this.sliderPopupSelected(0)
  }
}
</script>

<style scoped>
.box-card-mis-seguros-formatter .box-tooltip-generico-formatter {
  border-left: 4em solid transparent;
  border-right: 4em solid transparent;
  border-bottom: 2em solid #ffffff;
  position: absolute;
  top: -1.8em;
}

.box-card-mis-seguros-formatter .box-tooltip-formatter1 {
  left: calc(1%);
}

.box-card-mis-seguros-formatter .box-tooltip-formatter3 {
  right: calc(1%);
}

.box-card-mis-seguros-formatter {
  width: 340px;
}

.box-guia-formatter {
  display: flex;
  padding-left: 1.5em;
}

.box-guia-formatter div {
  height: 6px;
  width: 6px;
  border-radius: 3px;
  margin-right: 5px;
  background: #D9D9D9;

}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/TooltipGuiaMisSeguros.vue